/* eslint-disable import/prefer-default-export */
import makeConstants from 'lib/makeConstants';

export const promiseStatuses = makeConstants('pending', 'success', 'error');
